// import React from 'react';
import ReactDOM from 'react-dom/client';
import App from './App';
import './globals.css';
import { HelmetProvider } from 'react-helmet-async';
// import { hydrate, render } from "react-dom";

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  // <React.StrictMode>
  // </React.StrictMode>
    <HelmetProvider>
      <App />
    </HelmetProvider>
);

// const rootElement = document.getElementById('root');
// const app = (
//   <HelmetProvider>
//     <App />
//   </HelmetProvider>
// );

// if (rootElement.hasChildNodes()) {
//   hydrate(app, rootElement);
// } else {
//   render(app, rootElement);
// }

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
